import axios from 'axios';
import { API_BASE_URL, handleApiError } from './_apiBase';

// ── myUplink / Heat Pump ─────────────────────────────────────────────────────

export const fetchMyUplinkStatus = async (): Promise<any> => {
    try {
        const res = await axios.get(`${API_BASE_URL}/myuplink/status`);
        return res.data;
    } catch (error) { return handleApiError(error, 'Hämta status från myUplink'); }
};

export const configureMyUplink = async (cfg: {
    client_id: string;
    client_secret: string;
    poll_interval_seconds?: number;
    enabled?: boolean;
}): Promise<any> => {
    try {
        const res = await axios.post(`${API_BASE_URL}/myuplink/configure`, cfg);
        return res.data;
    } catch (error) { return handleApiError(error, 'Ställa in myUplink'); }
};

export const setMyUplinkEnabled = async (enabled: boolean): Promise<any> => {
    try {
        const res = await axios.patch(`${API_BASE_URL}/myuplink/enabled`, { enabled });
        return res.data;
    } catch (error) { return handleApiError(error, 'Slå på eller av myUplink'); }
};

export const triggerMyUplinkPoll = async (): Promise<any> => {
    try {
        const res = await axios.post(`${API_BASE_URL}/myuplink/poll`);
        return res.data;
    } catch (error) { return handleApiError(error, 'Hämta från myUplink nu'); }
};

export const fetchMyUplinkSystems = async (): Promise<any[]> => {
    try {
        const res = await axios.get(`${API_BASE_URL}/myuplink/systems`);
        return res.data;
    } catch (error) { return handleApiError(error, 'Hämta system från myUplink'); }
};

export const fetchMyUplinkDevicePoints = async (deviceId: string): Promise<any[]> => {
    try {
        const res = await axios.get(`${API_BASE_URL}/myuplink/devices/${deviceId}/points`);
        return res.data;
    } catch (error) { return handleApiError(error, 'Hämta enhetens mätvärden'); }
};

export interface MyUplinkAlarm {
    id: string;
    alarmNumber: number;
    header: string;
    description: string;
    equipName: string;
    severity: number;   // 0=Info, 1=Warning, 2=Error, 3=Critical
    status: string;     // e.g. 'DismissedByDevice', 'ResetByUserFromCloud', 'Active'
    createdDatetime: string;
    statusHistory: any[] | null;
    deviceId: string;
    systemId?: string;
    systemName?: string;
}

export const fetchMyUplinkAlarms = async (): Promise<MyUplinkAlarm[]> => {
    try {
        const res = await axios.get(`${API_BASE_URL}/myuplink/alarms`);
        return res.data;
    } catch (error) { return handleApiError(error, 'Hämta larm från myUplink'); }
};

export const fetchMyUplinkNotifications = async (): Promise<MyUplinkAlarm[]> => {
    try {
        const res = await axios.get(`${API_BASE_URL}/myuplink/notifications`);
        return res.data;
    } catch (error) { return handleApiError(error, 'Hämta meddelanden från myUplink'); }
};

export interface MyUplinkEndpointDef {
    key: string;
    label: string;
    description: string;
    path: string;
    method: 'GET';
    pathParams: string[];
    queryParams?: { name: string; label: string; optional?: boolean }[];
}

export const fetchMyUplinkEndpoints = async (): Promise<MyUplinkEndpointDef[]> => {
    try {
        const res = await axios.get(`${API_BASE_URL}/myuplink/endpoints`);
        return res.data;
    } catch (error) { return handleApiError(error, 'Hämta adresser från myUplink'); }
};

export const queryMyUplinkEndpoint = async (
    key: string,
    params: Record<string, string>
): Promise<unknown> => {
    try {
        const res = await axios.get(`${API_BASE_URL}/myuplink/query/${encodeURIComponent(key)}`, { params });
        return res.data;
    } catch (error) { return handleApiError(error, `Querying myUplink endpoint ${key}`); }
};
